import { Component, ViewEncapsulation, OnInit, ElementRef, ViewChild } from '@angular/core';
import { KYMW0E00Model } from './kymw0e00.model';
import { PlessViewHelperSub } from '../../kymw00/pless-view-helper-sub';
import { KYMW00Model } from '../../kymw00/kymw00.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { KYMW0E00InputModel } from './vo/kymw0e00-input.model';
import { PlessViewUtilsSub } from '../../kymw00/pless-view-utils-sub.service';
import { KYMW0E00OutputModel } from './vo/kymw0e00-output.model';
import { FlexGrid } from '@grapecity/wijmo.grid';
import { GetChangeInfoService } from './api-services/get-change-info.service';

/**
 * 使用ページ確認画面を管理するクラス
 *
 * @export KYMW0E00Component
 * @class KYMW0E00Component
 */
@Component({
  selector: 'app-kymw0e00',
  templateUrl: 'kymw0e00.component.html',
  styleUrls: ['kymw0e00.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class KYMW0E00Component extends PlessViewHelperSub implements OnInit {

  // 親画面からの連携値
  param: any;

  kymw0E00Model: KYMW0E00Model = new KYMW0E00Model();
  setKYMW0E00Parameter: Function;

  /**
   * 受渡情報
   */
  private inputVo: KYMW0E00InputModel = null;
  @ViewChild('dtg_UseImage', { static: true }) dtg_UseImage: FlexGrid;
  @ViewChild('btn_Close', { static: true }) btn_Close: ElementRef;

  // ウィンドウを閉じる際の処理
  closeFunction: Function;
  selfManage: KYMW0E00Model;

  /**
   *Creates an instance of KYMW0E00Component.
   * @param {PlessDialogServiceSub} dialogService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW0E00Component
   */
  constructor(
    public dialogService: PlessDialogServiceSub,
    private kymw00Model: KYMW00Model,
    private elementRef: ElementRef,
    private getChangeInfoService: GetChangeInfoService,
  ) {
    super(kymw00Model);
  }

  /**
   * 初期処理
   *
   * @memberof KYMW0E00Component
   */
  public ngOnInit(): void {
    this.kymw0E00Model.kymw0E00Component = this;
    this.componentName = 'KYMW0E00';

    // 受渡情報を元に対象データを検索する
    const vo = this.inputVo;
    this.getChangeInfoService.execute(this.kymw0E00Model, vo);
    this.dtg_UseImage.itemsSourceChanged.addHandler(() => {
      this.dtg_UseImage.select(-1, -1);
    });
  }

  /**
   * 親画面に対して公開し、親画面からのパラメタを受け取るためのメソッド
   *
   * @param {*} param 受け渡すデータ
   * @memberof KYMW0E00Component
   */
  public setInterfaceParam(param: any): void {
    this.inputVo = <KYMW0E00InputModel>param;
    // 処理区分をmanageに設定
    this.kymw0E00Model.processDiv = this.inputVo.processDiv;

    // 検索条件をmanageに設定
    this.kymw0E00Model.imageId = this.inputVo.imageID;
    this.kymw0E00Model.imageName = this.inputVo.imageName;
    this.kymw0E00Model.imageFileName = this.inputVo.imageFileName;
    this.kymw0E00Model.startOrderCodeBefore = this.inputVo.startOrderCodeBefore;
    this.kymw0E00Model.endOrderCodeBefore = this.orderCodeFormat(this.inputVo.endOrderCodeBefore);
    this.kymw0E00Model.startOrderCodeAfter = this.inputVo.startOrderCodeAfter;
    this.kymw0E00Model.endOrderCodeAfter = this.orderCodeFormat(this.inputVo.endOrderCodeAfter);
  }

  /**
   * 変更確認ボタンを押下した時に呼び出されるメソッド。
   * @param event コールバック・イベントへの参照
   */
  public eventChangeInfoHandler(event: Event): void {
    // 「1:変更OK」を設定
    this.exitKYMW0E00(1);
  }

  /**
   * 閉じるボタンを押下した時に呼び出されるメソッド。
   * @param event コールバック・イベントへの参照
   */
  public eventCloseWindowHandler(event: Event): void {
    // 「2:キャンセル」を設定
    this.exitKYMW0E00(2);
  }

  /**
   * 結果を呼び出し元画面へ返却する
   */
  public exitKYMW0E00(change = 0): void {

    const outputVO: KYMW0E00OutputModel = new KYMW0E00OutputModel();
    outputVO.changeButton = change;
    outputVO.processDiv = this.kymw0E00Model.processDiv;

    // 呼び出し元の画面に結果を返却する
    this.setKYMW0E00Parameter(outputVO);

    // 画面を閉じる
    this.closeFunction();
  }


  /**
   * 受注コードを表示用のデータに変換する
   */
  private orderCodeFormat(baseStr: string): string {
    // 空白またはALL９の場合に文言の置き換えを行う
    if (PlessViewUtilsSub.isEmpty(baseStr) || baseStr === '9999999') {
      return '無期限';
    }
    return baseStr;
  }

  /**
   * 列のハイライトを調整するメソッド
   *
   * @memberof KYMW0E00Component
   */
  public setColorPattern(): void {
    const grid: FlexGrid = this.dtg_UseImage;
    const rowIndex: number = grid.selection.row;                                // 選択行インデックス

    for (let loop = Number(0); loop < grid.rows.length; loop++) {
      if (this.kymw0E00Model.colorList[loop] === this.kymw0E00Model.very_final_proof) {
        if (rowIndex === loop) {
          grid.rows[loop].cssClass = '';
        } else {
          grid.rows[loop].cssClass = 'bg-pink';
        }
      }
    }
  }
}
